<template>
  <footer class="site-footer">
    <div class="footer-inner">
      <div class="footer-brand">
        <img src="/public/logo.png" class="footer-logo" />
        <span class="footer-name">云南信和科技有限公司</span>
      </div>
      <div class="footer-info">
        <span>地址：云南省昆明市五华区壹方大厦1606室</span>
        <span>电话：13320521960</span>
        <span>邮箱：zry@xinhe.pro</span>
      </div>
      <div class="footer-copy">
        Copyright © 2022 云南信和科技有限公司 | 滇ICP备2022000887号
      </div>
    </div>
  </footer>
</template>
<script>
  export default {}
</script>
<style lang="less">
.site-footer {
  width: 100%;
  background: #1a1a2e;
  border-top: 1px solid rgba(0,0,0,0.05);
  padding: 40px 0 28px 0;
  .footer-inner {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 32px;
    text-align: center;
  }
  .footer-brand {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    margin-bottom: 16px;
    .footer-logo {
      height: 28px;
      width: auto;
      opacity: 0.85;
      filter: brightness(0) invert(1);
    }
    .footer-name {
      font-size: 15px;
      font-weight: 600;
      color: rgba(255,255,255,0.7);
      letter-spacing: 1px;
    }
  }
  .footer-info {
    display: flex;
    justify-content: center;
    gap: 28px;
    flex-wrap: wrap;
    margin-bottom: 16px;
    span {
      font-size: 13px;
      color: rgba(255,255,255,0.4);
    }
  }
  .footer-copy {
    font-size: 12px;
    color: rgba(255,255,255,0.25);
  }
}
@media (max-width: 768px) {
  .site-footer {
    padding: 28px 0 20px 0;
    .footer-inner { padding: 0 16px; }
    .footer-info {
      flex-direction: column;
      gap: 8px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue